import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import constants from '../../../abstracts/constants';
import { cherry, brownGrey, scienceBlue, abbey, alabaster } from '../../../abstracts/colours';

const useStyles = makeStyles({
  option: {
    fontSize: 20,
    margin: '0 8px',
    '&[aria-selected="true"]': {
      color: '#206699',
      backgroundColor: 'inherit',
    },

    '&[data-focus="true"]': {
      borderRadius: '10px',
      backgroundColor: alabaster,
      color: scienceBlue,
    },

    '&:hover': {
      borderRadius: '10px',
      backgroundColor: alabaster,
      color: scienceBlue,
    },
  },
  popupIndicator: {
    color: scienceBlue,
  },
  endAdornment: {
    top: 'calc(50% - 18px)',
  },
  inputRoot: {
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: scienceBlue,
      borderWidth: '2px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: scienceBlue,
      borderWidth: '2px',
    },
    '&.Mui-disabled': {
      backgroundColor: alabaster,
      borderRadius: '10px',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: alabaster,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderColor: '#ced4d9',
      borderRadius: '10px',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: cherry,
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: '#ced4d9',
    },
    cursor: 'pointer',
    height: 64,
    fontSize: 20,
    '&:hover input::placeholder, &.Mui-focused input::placeholder': {
      color: brownGrey,
    },
    '&:hover input.Mui-disabled::placeholder': {
      color: brownGrey,
    },
  },
  input: {
    cursor: 'pointer',
    fontFamily: constants.sourceSansPro,
    '&::placeholder': {
      fontFamily: constants.sourceSansPro,
      color: brownGrey,
      opacity: 1,
    },
  },
  paper: {
    margin: '8px 0',
    borderRadius: '10px',
    fontFamily: constants.sourceSansPro,
  },
  listbox: {
    margin: '8px 0',
  },
  selectedOptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
  },
  label: {
    marginLeft: '8px',
    lineHeight: 1.5,
  },
  selectedIcon: {
    display: 'flex',
    alignSelf: 'center',
  },
  clearIndicator: {
    color: scienceBlue,
  },
});

export const StyledTextFieldContainer = styled.div`
  height: 100%;
`;

export const ErrorMsg = styled.div`
  color: ${cherry};
  margin-left: 14px;
`;

export const HelperText = styled.div`
  font-family: SourceSansPro;
  font-size: 14px;
  color: ${abbey};
  margin-left: 16px;
`;

export const DropdownContainer = styled.div`
  min-height: 87px;
  & .MuiAutocomplete-root[aria-expanded='true'] {
    .text-field-container {
      min-height: auto;
      height: auto;
    }
    .errorMsg,
    .helperText {
      display: none;
    }
  }
`;

export default useStyles;
